<script lang="ts">
  import Navbar from "./components/Navbar.svelte";
  import Router from "svelte-spa-router";
  import { routes } from "./routes/index";

  function scrollToTop() {
    window.scrollTo(0, 0);
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css"
  />
</svelte:head>

<main>
  <Navbar />
  <Router {routes} on:routeLoaded={scrollToTop} />
</main>

<style>
  main {
    text-align: center;
    max-width: 512px;
    margin: 0 auto;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
